import type { RouteRecordRaw } from 'vue-router';

export const analyticsRoutes = [
  {
    path: 'analytics',
    name: 'analytics',
    component: () => import('./AnalyticsPage.vue'),
    meta: { title: 'Analytics' },
  },
  {
    path: 'transactions',
    name: 'transactions',
    component: () => import('./TransactionsPage.vue'),
    meta: { title: 'Transactions' },
  },
] as const satisfies readonly RouteRecordRaw[];
